import { defineMessages } from 'react-intl';

export default defineMessages({
  pricingSubtotalFinanceLegend: {
    id: 'Pdpv2.price.addToCartSimplifiedView.financing.pricingSubtotalFinanceLegendMobile',
    defaultMessage: 'As low as',
  },
  pricingSubtotalFinanceLegendPostValue: {
    id: 'Pdpv2.price.addToCartSimplifiedView.financing.pricingSubtotalFinanceLegendPostValue',
    defaultMessage: 'with financing',
  },
  affirmLogoAlt: {
    id: 'Pdpv2.addToCartSimplifiedView.affirmLogo.alt',
    description: 'Alternative text to Affitm logo',
    defaultMessage: 'Affirm',
  },
  affirmLegend: {
    id: 'Pdpv2addToCartSimplifiedView.affirm.legend',
    description: 'Legend for Affirm rowz',
    defaultMessage: 'As low as 0% APR financing.',
  },
  affirmInfoAlt: {
    id: 'Pdpv2.addToCartSimplifiedView.affirmInfo.alt',
    description: 'Affirm Icon Aria Label',
    defaultMessage: 'Affirm Information Link',
  },
  affirmWithLogoLegend: {
    id: 'Pdpv2.addToCartSimplifiedView.affirmWithLogo.legend',
    description: 'Affirm Icon with text',
    defaultMessage: 'with {affirmLogo}',
  },
  stockLegend: {
    id: 'Pdpv2.addToCartSimplifiedView.stock.legend',
    defaultMessage: 'In-stock and ready to ship.',
  },
  shippingLegend1: {
    id: 'Pdpv2.addToCartSimplifiedView.shipping.legend1',
    defaultMessage: 'Items may ship separately. ',
  },
  shippingLegend4: {
    id: 'Pdpv2.addToCartSimplifiedView.shipping.legend4',
    defaultMessage: 'Note: ',
  },
  shippingLegend5: {
    id: 'Pdpv2.addToCartSimplifiedView.shipping.legend5',
    defaultMessage: 'Shipping may be impacted by carrier delays',
  },
  shippingLegend6: {
    id: 'Pdpv2.addToCartSimplifiedView.shipping.legend6',
    defaultMessage:
      'Two Shipping Options Available (shipping may be impacted by carrier delays):',
  },
  shippingLegend2: {
    id: 'Pdpv2.addToCartSimplifiedView.shipping.legend2',
    defaultMessage: ' Expedited shipping options ',
  },
  shippingLegend3: {
    id: 'Pdpv2.addToCartSimplifiedView.shipping.legend3',
    defaultMessage: ' available at checkout.',
  },
  errorAddingItems: {
    id: 'Pdpv2.addToCartSimplifiedView.addToCart.errorAddingItems',
    defaultMessage: 'Something went wrong, please try again.',
  },
  freeGiftAovAdvertise: {
    id: 'Pdpv2.addToCartSimplifiedView.addToCart.freeGiftAovAdvertise',
    description: 'Advertise upper the "Add items to cart"',
    defaultMessage: 'Select your free gifts on the next screen',
  },
  freeGiftAovAdvertiseImgAlt: {
    id: 'Pdpv2.addToCartSimplifiedView.addToCart.freeGiftAovAdvertiseImgAlt',
    description: 'Alt for advertise icon',
    defaultMessage: 'Free Gifts',
  },
  priceOrFinancing: {
    id: 'Pdpv2.addToCartSimplifiedView.addToCart.priceOrFinancing',
    description: 'Separator between price and financing',
    defaultMessage: 'or',
  },
  affirmAsLowAs: {
    id: 'Pdpv2.addToCartSimplifiedView.affirmAsLowAs',
    defaultMessage: 'As low as',
  },
  affirmAPRText: {
    id: 'Pdpv2.addToCartSimplifiedView.affirmAPRText',
    defaultMessage: 'at 0% APR financing',
  },
  totalPrice: {
    id: 'Pdpv2.addToCart.totalPrice',
    defaultMessage: 'Total Price',
  },
});
